import React from "react";

import ClientGuaranteesDataTable from "./ClientGuaranteesDataTable";

/**
 * Page wrapper for client guarantee configurations.
 */
const ClientGuaranteesPage = () => {
  return (
    <div className="sub-content">
      <ClientGuaranteesDataTable />
    </div>
  );
};

export default ClientGuaranteesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-guarantees/ClientGuaranteesPage.js